var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BjPage", {
    ref: "BjPage",
    attrs: {
      "query-params": _vm.queryParams,
      "col-span": _vm.colSpan,
      "get-action": _vm.queryApi,
      serial: _vm.serial,
      selection: _vm.selection,
      "before-reset-search": _vm.beforeResetSearch,
    },
    on: {
      handleSelectionChange: _vm.handleSelectionChange,
      showSetting: _vm.SortableTable.show,
      "header-dragend": _vm.SortableTable.handleHeaderDragend,
      "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
    },
    scopedSlots: _vm._u([
      {
        key: "baseForm",
        fn: function () {
          return [
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("goodsPage.skuName"),
                      prop: "skuName",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("goodsPage.skuName"),
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.queryParams.skuName,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "skuName", $$v)
                        },
                        expression: "queryParams.skuName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("goodsPage.skuCode"),
                      prop: "skuCode",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("goodsPage.skuCode"),
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.queryParams.skuCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "skuCode", $$v)
                        },
                        expression: "queryParams.skuCode",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.statusText") } },
                  [
                    _c("BjSelectLov", {
                      attrs: {
                        "option-list": _vm.GOODS_AUDIT_STATUS_STRING_LIST,
                        placeholder: _vm.$t("table.statusText"),
                        multiple: "",
                      },
                      model: {
                        value: _vm.tempStatus,
                        callback: function ($$v) {
                          _vm.tempStatus = $$v
                        },
                        expression: "tempStatus",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c("BjSelectLov", {
                  attrs: {
                    "option-list": _vm.customerList,
                    placeholder: _vm.$t("customerNameText"),
                  },
                  model: {
                    value: _vm.queryParams.cusId,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "cusId", $$v)
                    },
                    expression: "queryParams.cusId",
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "tableOperation",
        fn: function () {
          return [
            _c(
              "el-col",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.onAuditList },
                  },
                  [_vm._v(_vm._s(_vm.$t("goodsPage.review")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.onCancelList },
                  },
                  [_vm._v(_vm._s(_vm.$t("goodsPage.rejection")))]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "tableColumn",
        fn: function () {
          return [
            _vm._l(_vm.dropCols, function (col, index) {
              return [
                col.prop !== "bjTableAction"
                  ? _c("el-table-column", {
                      key:
                        "col_" +
                        index +
                        "_" +
                        col.prop +
                        "_" +
                        (col.width || "auto"),
                      attrs: {
                        prop: col.prop,
                        label: col.label,
                        width: col.width || "auto",
                        fixed: col.fixed || false,
                        align: "center",
                        "class-name": "item",
                        "show-overflow-tooltip": col.prop !== "bjTableAction",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                false
                                  ? void 0
                                  : col.prop == "cusId"
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm.customerList.bjGet(
                                            scope.row.cusId
                                          )
                                        )
                                      ),
                                    ]
                                  : col.prop === "materialMainImages"
                                  ? [
                                      _c("BjViewUrl", {
                                        attrs: {
                                          height: "80px",
                                          url: (scope.row[col.prop] || [])[0],
                                          preview: "",
                                        },
                                      }),
                                    ]
                                  : col.prop === "status"
                                  ? _c("el-tag", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              _vm.GOODS_AUDIT_STATUS_LIST.bjGet(
                                                scope.row[col.prop]
                                              )
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("timeFilters")(
                                            scope.row[col.prop],
                                            scope.row[col.prop]
                                          )
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
                col.prop === "bjTableAction"
                  ? _c("el-table-column", {
                      key:
                        "col_" +
                        index +
                        "_" +
                        col.prop +
                        "_" +
                        (col.width || "auto"),
                      attrs: {
                        prop: col.prop,
                        label: col.label,
                        width: col.width || "auto",
                        fixed: col.fixed || "right",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _vm.setFlag == _vm.GOODS_COMBO_TYPES.ORDINARY
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessGoodsAuditSkuOrdinaryCSGView",
                                            arg: "BusinessGoodsAuditSkuOrdinaryCSGView",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onLook(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    )
                                  : _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessGoodsAuditSkuPackageCSGView",
                                            arg: "BusinessGoodsAuditSkuPackageCSGView",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onLook(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                (props.row.status == 2 ||
                                  props.row.status == 4) &&
                                _vm.setFlag == _vm.GOODS_COMBO_TYPES.ORDINARY
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessGoodsAuditSkuOrdinaryCSGAudit",
                                            arg: "BusinessGoodsAuditSkuOrdinaryCSGAudit",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onAudit(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("table.auditText"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                (props.row.status == 2 ||
                                  props.row.status == 4) &&
                                _vm.setFlag == _vm.GOODS_COMBO_TYPES.PACKAGE
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessGoodsAuditSkuPackageCSGAudit",
                                            arg: "BusinessGoodsAuditSkuPackageCSGAudit",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onAudit(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("table.auditText"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
              ]
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }